import React from 'react';
import './styles.sass';

const Button = ({ children, variant, ...props }) => (
  <button className="Button" data-variant={variant} type="button" {...props}>
    {children}
  </button>
);

export default Button;
